import React, { Component }     from "react";
import { Button, PageHeader, DropdownButton, MenuItem, Panel, Row,Tab, Tabs, Col } from "react-bootstrap";
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import BootstrapTable           from 'react-bootstrap-table-next';
import ModalCreateFolder        from "../../components/modal/ModalCreateFolder";
import ModalMoveProgramToFolder from "../../components/modal/ModalMoveProgramToFolder";
import ModalTrainerDetail       from "../../components/modal/ModalTrainerDetail";
import ModalAlert               from "../../components/modal/ModalAlert";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import RenderLander             from "../../components/utils/RenderLander";
import BillingForm              from "../../screens/billing/BillingForm";
import { Colors }               from "../../utils/Colors";
import TrainerList              from "../../screens/trainer/TrainerList";

import ModalTrainerTextMsg                 from "../../components/modal/ModalTrainerTextMsg";
import { invokeGetTrainerProfileDetail }   from "../../utils/AwsInvoke";
import { doesTrainerHaveValidPhoneNumber } from "../../utils/CheckIfValidPhoneNumber";
import "../../css/report/ReportDashboard.css";

/*function priceFormatter(column, colIndex) {
  return (
    <h5><strong>{ column.text }</strong></h5>
  );
}
const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#fff"
};*/

var products = [/*{id: 1,name: "Product1",price: 120,}*/];

const columns = [{
    dataField: "client_name",
    text: "Client Name",
    //sort: true,
    headerStyle: () => {
        return { width: "25%", textAlign: "center", outline: 0, border: 0 };
    }
},{
    dataField: "trainer_name",
    text: "Trainer Name",
    //sort: true,
    headerStyle: () => {
        return { width: "15%", textAlign: "center" };
    }
}, {
    dataField: "program",
    text: "Program",
    //sort: true,
    headerStyle: () => {
        return { width: "25%", textAlign: "center" };
    }
}, {
    dataField: "program_date_created",
    text: "Date Created",
    //sort: true,
    headerStyle: () => {
        return { width: "10%", textAlign: "center" };
    }
}, {
    dataField: "last_login",
    text: "Last Login",
    //sort: true,
    headerStyle: () => {
        return { width: "16%", textAlign: "center" };
    }
}, {
    dataField: "sms_icon",
    text: "Msg Trainer",
    headerStyle: () => {
        return { width: "9%", textAlign: "center" };
    }
    //headerFormatter: priceFormatter
}];

const p4l_castro = "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30";
const p4l_fidi   = "c84934b0-ebf0-11e9-911a-fbdac363f28e";
const p4l_hayes  = "001877c0-ebf1-11e9-a945-d5dded95ac71";
const asp_id     = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";

export default class ReportDashboard extends Component {
    constructor(props) {
        super(props);
        var globalCompanyId       = sessionStorage.getItem('company_id');
        var globalAdminUserId     = localStorage.getItem('globalAdminUserId');
        var globalAdminUserEmail  = localStorage.getItem('globalAdminUserEmail');
        var globalAdminUserRoleId = localStorage.getItem('globalAdminUserRoleId');

        this.state = {
          isLoading: true,
          exerciseSaved: false,
          adminUserId:     globalAdminUserId,
          adminCompanyId:  globalCompanyId,
          adminUserEmail:  globalAdminUserEmail,
          adminUserRoleId: globalAdminUserRoleId,
          //showModalTrainerTextMsg: false,
          //showModalTrainerDetail: false,
          //showModalAlert: false
        };
    }

    componentDidMount() {
        console.log("componentDidMount >>>>>>>>>>>>>>>");
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            var role_id    = this.state.adminUserRoleId;
            var trainer_id = this.state.adminUserId; //"b569d320-5c19-11e9-bda3-8726ddea8a40";// info accelerate - this.state.trainerId;

            this.getTrainerDetail(trainer_id, role_id);
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount () {
        console.log("going to unmount!!!");
        this.setState({
            showModalTrainerDetail: false,
            showModalTrainerTextMsg: false,
            showModalAlert: false
        })
    }

    getTrainerDetail = async (trainer_id, role_id) => {
        var show_single_trainer = false; // show all trainers from a gym location
        var number_of_total_results   = 200;
        const results = await invokeGetTrainerProfileDetail(trainer_id, role_id, show_single_trainer, number_of_total_results);

        if(results) {
            var company_data = results.company_data;
            var trainer_data = results.data;

            this.getTrainerClients(trainer_data, company_data);

            this.setState({
                //trainerDetail: trainer_data,
                showModalTrainerDetail: false,
                showModalTrainerTextMsg: false,
                showModalAlert: false
            })
        }
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    sms = (trainer_id, trainer_name, trainer_phone, athlete_id, athlete_name, athlete_last_login, program_name) => {
        var trainer_number = doesTrainerHaveValidPhoneNumber(trainer_phone);

        if(trainer_number == false) {
            //alert("Sorry, before you send a text message, you need to add a valid trainer number.")
            var body_text  = "Sorry, before you send a text message, you need to add a valid trainer number.";
            this.setModalAlertProps("Warning", body_text, true); // title_text, body_text, show_modal
            this.setState({ isLoading: false, showLoadingBar: "none" });
            return false;
        }

        this.setState({
            showModalTrainerTextMsg: true,
            trainerId:               trainer_id,
            trainerName:             trainer_name,
            trainerTextPhone:        trainer_number,
            athleteId:               athlete_id,
            athleteName:             athlete_name,
            athleteLastLogin:        athlete_last_login,
            programName:             program_name,
        });
    }


    gotoClientProfile (athlete_id) {
        this.props.history.push("/client/detail/"+athlete_id);
    }

    gotoTrainerProfile (trainer_id, trainer_full_name, company_id, company_name, phone, email) {

        /*console.log("Trainer_id: " + trainer_id);
        console.log("company_id: " +  company_id);
        console.log("company_name: " +  company_name);
        console.log("phone: " + phone);
        console.log("email: " + email);*/

        var location_abbrev;

        // Where are other company names for someone like Creig Nakano //
        console.log("company_name: " + company_name);

        if(company_id == "001877c0-ebf1-11e9-a945-d5dded95ac71") {
            location_abbrev = "hayes";
            //company_name = "P4L Training - Hayes Valley"
        } else if(company_id == "c84934b0-ebf0-11e9-911a-fbdac363f28e") {
            location_abbrev = "fidi";
            //company_name = "P4L Training - FiDi";
        } else if(company_id == "4b07edc0-ebf0-11e9-85dd-9b2fcf560e30") {
            location_abbrev = "castro";
            //company_name = "P4L Training - Market/Castro";
        }

        this.setState({
            showModalTrainerDetail: true,
            trainerId:              trainer_id,
            trainerName:            trainer_full_name,
            trainerPhoneNum:        phone,
            trainerEmail:           email,
            trainerCompanyId:       company_id,
            trainerCompanyName:     company_name,
            showTrainerForm:        false,
            trainerLocationAbbrev:  location_abbrev,
        });

        /*trainerLocationAbbrev  = {this.state.location_abbrev}*/
    }

    resetTrainerList = () => {
        //this.getMemberList();
        // empty function
    }

    getTrainerClients (trainer_data, company_data) {
        var total_programs_per_client;
        var details_arr = [];
        var ctr         = 1;
            products    = []; //reset global array for table; req'd otherwise modals don't show if you veer away from page and then back to this page

        for(var key in trainer_data) {
            var data2 = trainer_data[key];

            //if(data2.length < 1)
            //    details_arr.push(<div key={uniqueId()}>No programs have been assigned to clients yet.</div>);
            var ctr = 1;
            for(var key2 in data2) {
                var athlete_id         = data2[key2].athlete_id;
                var first_name         = data2[key2].first_name;
                var last_name          = data2[key2].last_name;
                var trainer_phone      = data2[key2].trainer_phone;
                var trainer_email      = data2[key2].trainer_email;
                var company_id         = data2[key2].company_id;
                var company_name       = data2[key2].company_name;


                var trainer_id         = data2[key2].trainer_id;
                var trainer_first_name = data2[key2].trainer_first_name;
                var trainer_last_name  = data2[key2].trainer_last_name;
                var date_created       = data2[key2].date_created;
                var new_date           = new Date(date_created).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});
                var athlete_name       = first_name + " " + last_name;
                var trainer_full_name  = trainer_first_name + " " + trainer_last_name;
                var date_last_used     = data2[key2].ath_prog_date_last_used;
                var last_login_date    = "Never";
                var program_name       = data2[key2].name;


                if(date_last_used != null)
                    last_login_date = new Date(date_last_used).toLocaleString([], {month: 'short', day:'2-digit'}); //, hour: '2-digit', minute:'2-digit'});

                // hide null values //
                if(first_name != null && last_name != null) {
                    products.push({
                          id: uniqueId(), // id is required for unique keys, otherwise there's an error
                          client_name: <span
                                              className="reportDashClientName" style={{fontWeight: "bold", color: Colors.default_blue }}
                                              onClick={this.gotoClientProfile.bind(this, athlete_id)}>
                                                { ctr + ". " + athlete_name }
                                        </span>,
                          trainer_name: <span  key = {uniqueId()} className="reportDashClientName" style={{color: Colors.default_blue}}
                                               onClick={this.gotoTrainerProfile.bind(this, trainer_id, trainer_full_name, company_id, company_name, trainer_phone, trainer_email)}>
                                                { trainer_full_name }
                                        </span>,

                          program:      <span  className="reportDashClientName" style={{cursor: "none"}}>{program_name}</span>,
                          program_date_created:      <span  className="reportDashClientName" style={{cursor: "none"}}>{new_date}</span>,
                          last_login:   <span  className="reportDashClientName" style={{cursor: "none"}}>{last_login_date}</span>,
                          sms_icon:     <span  className="reportDashClientName"
                                               style={{ width: "100%", paddingTop:1, textAlign: "center"}}>
                                               <FontAwesomeIcon onClick={this.sms.bind(this, trainer_id, trainer_full_name, trainer_phone, athlete_id, athlete_name, last_login_date, program_name)}
                                                                icon="sms"
                                                                className="modalAlertIcon"
                                                                style={{color: Colors.default_blue}}/>
                                        </span>
                      })
                    ctr++;
                }
            }
        }
    }

    renderHome() {
        var customer_company = this.props.globalCompanyName; //process.env.REACT_APP_COMPANY_NAME;
        var exercise_saved;
        var tab2 = <div></div>;
        var tab3;
        var adminUserRoleId = this.state.adminUserRoleId;
        var user_role       = "Employee";
        //var show_trainers   = false;
        var company_id      = this.props.globalCompanyId;
        //console.log("adminUserRoleId: " + adminUserRoleId);

        //if(company_id == p4l_castro || company_id == p4l_fidi || company_id == p4l_hayes || company_id == asp_id) show_trainers = true;


        if(this.state.exerciseSaved)
            exercise_saved   = "Selection Saved.";

        return (
              <div className="programs">
                <PageHeader>
                    <span className="glyphicon glyphicon-cog" style={{ position:"relative", top:5, fontSize: '1em', color: Colors.primary_color, paddingRight:"16px" }}/>
                    Reports
                </PageHeader>
                <br/>
                    <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                              <Tab eventKey={1} title="Client Logins">
                                    <br/>

                                        View all recent client logins here and text message a trainer to ask questions.
                                        <br/>
                                <br/>
                                    <BootstrapTable keyField  = "id"
                                                    key       = {uniqueId()}
                                                    data      = { products }
                                                    columns   = { columns }
                                                    striped hover
                                                    //selectRow = { selectRow }
                                                    />
                               </Tab>
                              { /*}<Tab eventKey={3} title="Charts">

                              </Tab> */}
                  </Tabs>
              </div>
        );
    }

    render() {
        let closeModalAlert          = () => this.setState({ showModalAlert: false }); //close simple modal window
        let closeModalTrainerDetail  = () => this.setState({ showModalTrainerDetail: false }); //close simple modal window
        let closeModalTrainerTextMsg = (error) => this.setState({ showModalTrainerTextMsg: false, error: error }); //close modal window

        return (
              <div className="Home">
                {this.props.isAuthenticated ? this.renderHome() : <RenderLander /> }

                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}
                  {this.state.showModalTrainerDetail ?
                    <ModalTrainerDetail
                        show                  = {this.state.showModalTrainerDetail}
                        trainerName           = {this.state.trainerName}
                        trainerId             = {this.state.trainerId}
                        trainerPhoneNum       = {this.state.trainerPhoneNum}
                        trainerEmail          = {this.state.trainerEmail}
                        trainerCompanyId      = {this.state.trainerCompanyId}
                        trainerCompanyName    = {this.state.trainerCompanyName}
                        showTrainerForm       = {this.state.showTrainerForm}
                        resetTrainerList      = {this.resetTrainerList}
                        trainerLocationAbbrev = {this.state.trainerLocationAbbrev}
                        onHide={closeModalTrainerDetail}
                    />
                : null}
                {this.state.showModalTrainerTextMsg ?
                      <ModalTrainerTextMsg
                          onHide                  = {closeModalTrainerTextMsg}
                          trainerId               = {this.state.trainerId}
                          trainerName             = {this.state.trainerName}
                          trainerPhone            = {this.state.trainerTextPhone}
                          athleteId               = {this.state.athleteId}
                          athleteName             = {this.state.athleteName}
                          athleteLastLogin        = {this.state.athleteLastLogin}
                          programName             = {this.state.programName}
                          showModalTrainerTextMsg = {this.state.showModalTrainerTextMsg}
                      />
                 : null}
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/report/ReportDashboard.js